export Footer from './components/Footer';



/** WEBPACK FOOTER **
 ** ./src/app/modules/footer/index.js
 **/